import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../api/Axiosinstance";

/**
 * Public query exposing the platform configuration an admin sets on the
 * Settings > General page: app name, primary currency, timezone, logo,
 * support email, and which service modules (Rides/Stays/Pulo Assistants)
 * are currently enabled. Any component that needs to render one of these
 * consistently with the rest of the app should read from this hook rather
 * than hardcoding its own copy.
 */
export const useAppConfig = () => {
  return useQuery({
    queryKey: ["public", "appConfig"],
    queryFn: async () => {
      const response = await axiosInstance.get("/settings/public");
      return response.data?.data ?? response.data;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useAppConfig;
